import { resolveMediaSrc } from "./resolveMediaSrc";

export const CLIENT_ICON_EVENT = "client-icon:updated";

// The displayable badge src for a client-splash record. Only the resolved
// `iconFullUrl` is usable — the raw `iconUrl` may be a storage key. The icon
// is independent of the record's isActive flag (that only gates the splash).
export function iconSrcFromSplashRecord(record) {
  return resolveMediaSrc(record?.iconFullUrl || null) || null;
}

export function setClientIconUrl(iconUrl) {
  if (iconUrl) {
    localStorage.setItem("clientIconUrl", iconUrl);
  } else {
    localStorage.removeItem("clientIconUrl");
  }

  if (typeof window !== "undefined" && window.dispatchEvent) {
    window.dispatchEvent(
      new CustomEvent(CLIENT_ICON_EVENT, {
        detail: { iconUrl: iconUrl || null },
      })
    );
  }
}
